export default "__VITE_ASSET__DCc19TS$__";